import SmartToy from "@mui/icons-material/SmartToy";
import { Box, styled } from "convertupleads-theme";
import { forwardRef, useImperativeHandle, useMemo, useRef, useState } from "react";
import ReactQuill, { ReactQuillProps } from "react-quill";
import useBoolean from "../../../hooks/useBoolean";
import CustomToolbar from "./CustomToolbar";
import CustomEditor from "../../../common/Editor/CustomEditor";

const StyleEditor = styled(ReactQuill)(() => ({
  marginInline: "auto",
  padding: "0px",
  backgroundColor: "#F3F4F8",
  "& #editor-resizer .toolbar": {
    position: "absolute",
    top: "auto",
    bottom: "-55px",
  },
  "& .ql-toolbar.ql-snow": {
    borderRadius: "8px 8px 0 0",
    paddingTop: 10,
    paddingBottom: 10,
    border: "none",
  },
  "& .ql-container.ql-snow": {
    backgroundColor: "#fff",
    width: 820,
    minHeight: 750,
    height: "auto",
    margin: "130px auto 20px",
    fontSize: 14,
    color: "black",
    border: "1px solid #ddd",
    borderRadius: 0,
    padding: "25px",
  },
  "& .ql-snow .ql-formats": {
    padding: "4px",
    marginRight: 0,
    "&:last-of-type": {
      borderRight: "none",
    },
  },
}));

const TemplateEditor = forwardRef(({ onChange, height = "150px", maxHeight, value }, ref) => {
  const quillRef = useRef(null);
  const [isFocus, setIsFocus] = useState(false);
  const { setTrue: openAiModal, setFalse: _closeAiModal, value: _isAiModalOpen } = useBoolean();

  useImperativeHandle(ref, () => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      const toolbar = quill.getModule("toolbar");
      toolbar.addHandler("omega", <SmartToy />);
    }
    return {
      insertContent: (content) => {
        if (!quillRef.current) return;
        const quill = quillRef.current.getEditor();

        if (quill) {
          const cursorPosition = quill.getSelection(true);
          if (cursorPosition) {
            quill.insertText(cursorPosition.index, content);
          }
        }
      },
    };
  }, []);

  const modules = useMemo(() => {
    return {
      toolbar: {
        container: "#toolbar",
        handlers: {
          gpt: openAiModal,
        },
      },
    };
  }, []);
  return (
    <>
      <Box sx={{ position: "fixed", width: "100%", top: 68, zIndex: 9999 }}>
        <CustomToolbar onChange={onChange} quillRef={quillRef} />
      </Box>
      {/* <CustomEditor
                forwardedRef={quillRef}
                theme={"snow"}
                placeholder={"Write your content"}
                value={value}
                onChange={(value) => {
                    onChange(value);
                }}
                style={{ marginTop: '80px', height: '70vh', overflowY: 'scroll' }}
            /> */}
      <StyleEditor
        className="quill-editor"
        placeholder={isFocus ? "" : "Start typing here or paste content..."}
        height={height}
        maxHeight={maxHeight}
        ref={quillRef}
        modules={modules}
        onFocus={() => setIsFocus(true)}
        onBlur={() => setIsFocus(false)}
        onChange={onChange}
        value={value}
      />
    </>
  );
});

TemplateEditor.displayName = "Editor";

export default TemplateEditor;
